export default "__VITE_ASSET__22bc3b36__"